module.exports = __webpack_public_path__ + "static/img14-5a27170af773e71ee31a7a2e8351202f.jpg";